window.ThriveMapAssessmentAPI = new (function () {

    var self = this;
    var _protected = BaseAPI.call(self);

    _protected.setApiUrl(publicConfiguration['TalentAssessmentServer']);

    self.registerForAssessment = function (brandId, jobId, appId) {
        var defer = $q.defer();
        var payload = {
            application_id: appId,
            job_id: jobId
        };
        _protected.request("brands/" + brandId + "/candidates", "POST", payload)
            .then(function (res) {
                if (res && res.status === 200 && res.data) {
                    defer.resolve(res.data.data);
                } else {
                    defer.reject(res.data)
                }
            }, function (err) {
                defer.reject(err);
            });

        return defer.promise;
    };

    self.cancelCandidateAssessments = function (brandId, candidateId) {
        var defer = $q.defer();

        _protected.request("brands/" + brandId + "/candidates/" + candidateId, "DELETE")
            .then(function (res) {
                if (res && res.status === 200 && res.data && res.data.data) {
                    defer.resolve(res.data.data);
                } else {
                    defer.reject(res)
                }
            }, function (err) {
                defer.reject(err);
            });

        return defer.promise;
    };

    self.getAssessmentStatusForUsers = function (brandId, jobId, usersIds) {
        var defer = $q.defer();
        var payload = {
            user_ids: usersIds
        };
        _protected.request("brands/" + brandId + "/jobs/" + jobId + "/statuses", "GET", payload)
            .then(function (res) {
                if (res && res.status === 200 && res.data && res.data.data) {
                    defer.resolve(res.data.data.candidates);
                } else {
                    defer.reject(res)
                }
            }, function (err) {
                defer.reject(err);
            });

        return defer.promise;
    };

    self.getCandidateStatusDetails = function (brandId, thriveMapCandidateId) {
        var defer = $q.defer();

        _protected.request("brands/" + brandId + "/candidates/" + thriveMapCandidateId, "GET")
            .then(function (res) {
                if (res && res.status === 200 && res.data && res.data.data) {
                    defer.resolve(res.data.data);
                } else {
                    defer.reject(res)
                }
            }, function (err) {
                defer.reject(err);
            });

        return defer.promise;
    };
});

ThriveMapAssessmentAPI.STATUSES = {
    REMINDER_24HR: 'REMINDER_24HR',
    REMINDER_72HR: 'REMINDER_72HR',
    EXPIRED: 'EXPIRED',
    COMPLETED: 'COMPLETED',
    CANDIDATE_WITHDRAWN: 'CANDIDATE_WITHDRAWN',
    ASSESSMENT_NONE: 'ASSESSMENT_NONE',
    NOT_STARTED: 'NOT_STARTED'
};